// [Insider+] Routes inside the embedded insider-plus app. insider-plus is a
// separate repo that deploys on its own, so keep these in sync with its
// src/App.tsx — if a route is renamed there, links built from these paths
// break with no build or test failure here.
export const INSIDER_PLUS_APP_PATHS = {
  join: '/join',
  welcome: '/welcome',
  indicators: '/indicators',
  webinars: '/webinars',
  newsletters: '/newsletters',
  // insider-plus has no Metals Playbook index page (/metals-playbook
  // redirects to /welcome), so link straight to the course. The id is fixed
  // by the insider-plus seed (supabase/prod-seed/course-data.sql).
  metalsPlaybookCourse: '/metals-playbook/ec06aede-bd8c-4c8f-885a-d43b54a74837',
  // Opens Discourse in a new tab. Opened from the parent header the browser
  // usually blocks that tab, and insider-plus then shows an "Open forum"
  // button instead.
  forum: '/forum',
};
